import { styled } from "@mui/material/styles";

// Components
import { LoadingButton } from "@mui/lab";

// Themes
import theme from "../Theme";

const styledName = "Button";

export const StyledLoadingButton = styled(LoadingButton, { name: styledName })({
  "&": {
    fontFamily: "'Outfit', sans-serif",
    fontSize: "1.6rem",
    borderRadius: "6px",
    textTransform: "none",
    height: "36px",
    ".MuiButton-startIcon": {
      width: "2.2rem",
    },
    ".Mui-disabled": {
      backgroundColor: theme.palette.primary.light,
    },
    ":active": {
      transform: `scale(0.98)`,
    },
    transition: `transform 0.1s ease-out, background-color 0.3s ease-in`,
  },
});
